import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs, InputNumber } from 'antd';
import { Table, Button } from 'antd';
import { pageFinanceRecords, updateFinanceRecord, createFinanceRecord, IFinanceRecord, IFinanceRecordType, listFinanceRecordTypesByIncome, IPayWay, listPayWay } from '../../service/api/financeRecord';
import { FormInstance } from 'antd/lib/form/Form';
import { IStore, listStores } from '../../service/api/store';
import moment from 'moment';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
const { confirm } = Modal;
const { Option } = Select;

interface IFinanceRecordListProps {
  visible: boolean
  setVisible: (visible: boolean) => void;
  income: boolean | undefined
  filterStoreIds: number[] | undefined
  searchKeyword: string | undefined
}
const FinanceRecordList: React.FC<IFinanceRecordListProps> = ({
  visible,
  setVisible,
  income,
  filterStoreIds,
  searchKeyword,
}) => {
  const [financeRecords, setFinanceRecords] = useState<IFinanceRecord[]>();
  const [stores, setStores] = useState<IStore[]>();
  const [incomeTypes, setIncomeTypes] = useState<IFinanceRecordType[]>();
  const [outcomeTypes, setOutcomeTypes] = useState<IFinanceRecordType[]>();
  const [payWays, setPayWays] = useState<IPayWay[]>();
  const [financeRecordDetail, setFinanceRecordDetail] = useState<IFinanceRecord>();
  const [pageNum, setPageNum] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [loading, setLoading] = useState(false);
  const formRef = React.createRef<FormInstance>();
  const columns = [
    {
      title: '描述',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '金额',
      dataIndex: 'value',
      key: 'value',
      render: (text: any, record: any) => {
        if (record.income) {
          return record.value
        } else {
          return <span>-{record.value}</span>
        }
      }
    },
    {
      title: '类型',
      dataIndex: 'typeName',
      key: 'typeName',
    },
    {
      title: '付款方式',
      dataIndex: 'payWayName',
      key: 'payWayName',
    },
    {
      title: '所属门店',
      width: 180,
      dataIndex: 'storeName',
      key: 'storeName',
    },
    {
      title: '收入/支出',
      dataIndex: 'income',
      key: 'income',
      render: (text: any, record: any) => {
        if (record.income) {
          return <div style={{ backgroundColor: '#00A600', color: 'white', width: '50px', textAlign: 'center', borderRadius: '5px' }}>收入</div>
        } else {
          return <div style={{ backgroundColor: '#CE0000', color: 'white', width: '50px', textAlign: 'center', borderRadius: '5px' }}>支出</div>
        }
      }
    },
    {
      title: '记录人',
      width: 180,
      dataIndex: 'createdBy',
      key: 'createdBy',
    },
    {
      title: '时间',
      width: 180,
      dataIndex: 'recordTime',
      key: 'recordTime',
      render(val: Date) {
        return val ? moment(val).format('YYYY-MM-DD HH:mm') : <>&mdash;</>
      },
    },
    {
      title: '操作',
      key: 'action',
      render: (text: any, record: any) => {
        if (record.enable) {
          return <Space size="middle">
            <a onClick={() => {
              // console.log("record:" + JSON.stringify(record));
              setFinanceRecordDetail(record);
              setVisible(true);
            }}>编辑 </a>
            {/* <a onClick={e => { onEnable(e, record) }}>停用 </a> */}
          </Space>
        } else {
          return <Space size="middle">
            <a onClick={() => {
              // console.log("record:" + JSON.stringify(record));
              setFinanceRecordDetail(record);
              setVisible(true);
            }}>编辑 </a>
            {/* <a onClick={e => { onEnable(e, record) }}>启用 </a> */}
          </Space>
        }
      },
    }
  ];

  useEffect(() => {
    loadData();
  }, [pageNum, pageSize, filterStoreIds, searchKeyword]);

  useEffect(() => {
    if (financeRecordDetail) {
      let copyFormData = JSON.parse(JSON.stringify(financeRecordDetail))
      if (typeof (copyFormData.recordTime) === 'string') {
        copyFormData.recordTime = moment(new Date(financeRecordDetail.recordTime));
      }
      // copyFormData.incomeName = income?"收入":"支出";
      // console.log("xx"+copyFormData.incomeName);
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        formRef.current!.setFieldsValue(copyFormData);
      }, 100);
    }
  }, [financeRecordDetail]);

  // useEffect(() => {
  //   if (financeRecordDetail) {
  //     financeRecordDetail!.incomeName = income?"收入":"支出";
  //     console.log("xx"+JSON.stringify(financeRecordDetail));
  //     let copyFormData = JSON.parse(JSON.stringify(financeRecordDetail))
  //     if(typeof(copyFormData.recordTime) === 'string') {
  //       copyFormData.recordTime = moment(new Date(financeRecordDetail.recordTime));
  //     }
  //     // copyFormData.incomeName = income?"收入":"支出";
  //     // console.log("xx"+copyFormData.incomeName);
  //     // 设置100毫秒的延迟 确保from组件已经加载完毕
  //     setTimeout(() => {
  //       formRef.current!.setFields(copyFormData);
  //     }, 100);
  //   }
  // }, [income]);

  const loadData = () => {
    pageFinanceRecords(pageNum, pageSize, filterStoreIds || '', searchKeyword || '').then((info: any) => {
      setFinanceRecords(info?.data.list);
      setPageTotal(info?.data.total);
      // console.log("info:" + JSON.stringify(info.data));
    });
    listStores().then((info: any) => {
      setStores(info?.data);
    });
    listFinanceRecordTypesByIncome(true).then((info: any) => {
      setIncomeTypes(info?.data);
    });
    listFinanceRecordTypesByIncome(false).then((info: any) => {
      setOutcomeTypes(info?.data);
    });
    listPayWay().then((info: any) => {
      setPayWays(info?.data);
    });
  }

  const onFinish = (values: any) => {
    setLoading(true);
    if (financeRecordDetail) {
      updateFinanceRecord({
        ...values,
        id: financeRecordDetail.id
      }).then((info: any) => {
        // console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("更新成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    } else {
      createFinanceRecord({
        ...values,
        income: income,
      }).then((info: any) => {
        // console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("创建成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    }
  };

  // const onEnable = (e: any, item: IFinanceRecord) => {
  //   e.stopPropagation();
  //   confirm({
  //     title: '提示',
  //     icon: <ExclamationCircleOutlined />,
  //     content: item.enable?'确定要停用该财务记录吗？停用后无法被选到':'确定要启用该财务记录吗？',
  //     okText: '确定',
  //     okType: 'danger',
  //     cancelText: '取消',
  //     onOk() {
  //       enableFinanceRecord(item.id, !item.enable).then((info: any) => {
  //         // console.log("info:" + JSON.stringify(info));
  //         if(info){
  //           message.success("操作成功");
  //           loadData();
  //         }
  //       });
  //     },
  //     onCancel() {
  //     },
  //   });
  // }

  const onClose = () => {
    setFinanceRecordDetail(undefined);
    setVisible(false);
    if (formRef.current) {
      formRef.current!.resetFields();
    }
  }

  const onPageChange = (pageNum: number, pageSize?: number) => {
    setPageNum(pageNum);
    setPageSize(pageSize || 10);
    // setPageSize(info.data.pageSize);
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 20 },
    },
  };

  // 下拉框值
  const storeOptions = stores?.map((store) =>
    <Option key={store.id} value={store.id}>{store.name}</Option>);

  // 下拉框值
  const incomeTypesOptions = incomeTypes?.map((financeRecordType) =>
    <Option key={financeRecordType.id} value={financeRecordType.id}>{financeRecordType.name}</Option>);
  const outcomeTypesOptions = outcomeTypes?.map((financeRecordType) =>
    <Option key={financeRecordType.id} value={financeRecordType.id}>{financeRecordType.name}</Option>);

  // 下拉框值
  const payWayOptions = payWays?.map((payWay) =>
    <Option key={payWay.value} value={payWay.value}>{payWay.name}</Option>);

  return (
    <Card bordered={false}>
      <Table dataSource={financeRecords} columns={columns} pagination={false} />
      <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "10px" }}>
        <Pagination
          defaultCurrent={pageNum}
          total={pageTotal}
          pageSize={pageSize}
          hideOnSinglePage={false}
          className="pagination"
          onChange={onPageChange}
          showSizeChanger
          showTotal={total => `共计 ${total} 条`}
        />
      </div>
      <Drawer
        title={(financeRecordDetail ? "编辑" : "新增") + (income ? "收入" : "支出")}
        visible={visible}
        width={720}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onFinish} ref={formRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="name"
                label="描述"
                rules={[{ required: true, message: '请输入描述' }]}
              >
                <Input placeholder="请输入描述" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="value"
                label="金额"
                rules={[{ required: true, message: '请输入金额' }]}
              >
                <InputNumber style={{ width: '328px' }} placeholder="请输入金额" step="0.01"/>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="storeId"
                label="所属门店"
                rules={[{ required: false, message: '请输入所属门店' }]}
              >
                <Select placeholder="请选择门店" >
                  {storeOptions}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="typeId"
                label="类型"
                rules={[{ required: true, message: '请选择类型' }]}
              >
                <Select placeholder="请选择类型" >
                  {income|| financeRecordDetail?.income? incomeTypesOptions : outcomeTypesOptions}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="payWay"
                label="支付方式"
                rules={[{ required: true, message: '请选择支付方式' }]}
              >
                <Select placeholder="请选择支付方式" >
                  {payWayOptions}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="incomeName"
                label="收入/支出"
                rules={[{ required: false, message: '请选择收入/支出' }]}
              >
                {financeRecordDetail ? financeRecordDetail.income ? "收入" : "支出" : income ? "收入" : "支出"}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="recordTime"
                label="记录时间"
                rules={[{ required: true, message: '请选择记录时间' }]}
              >
                <DatePicker
                  format="YYYY-MM-DD HH:mm"
                  showTime
                />
              </Form.Item>
            </Col>
          </Row>
          {
            financeRecordDetail?<></>:<Form.List name="childrens">
            {(fields, { add, remove }) => (
              <>
                <div style={{ paddingBottom: '10px' }}>财务子项</div>
                {fields.map(({ name, fieldKey, ...restField }) => (
                  <Row gutter={16}>
                    <Col span={10}>
                      <Form.Item
                        {...restField}
                        name={[name, 'value']}
                        fieldKey={[fieldKey, 'value']}
                        rules={[{ required: true, message: '请输入金额' }]}
                      >
                        <InputNumber style={{ width: '270px' }} placeholder="请输入金额" step="0.01"/>
                      </Form.Item>
                    </Col>
                    <Col span={10}>
                      <Form.Item
                        {...restField}
                        name={[name, 'storeId']}
                        fieldKey={[fieldKey, 'storeId']}
                        rules={[{ required: true, message: '请选择门店' }]}
                      >
                        <Select placeholder="请选择门店" >
                          {storeOptions}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <MinusCircleOutlined onClick={() => remove(name)} style={{ paddingTop: '8px' }} />
                    </Col>
                  </Row>
                ))}
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    添加财务子项
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
          }
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </Card>
  );
};

export default FinanceRecordList;
